import { Box, CircularProgress, Button } from "@mui/material";
import CustomFileViewer from "Pages/AuthPages/Tasks/components/CustomFileViewer";
import { Modal } from "components/CustomModal";
import { getMethod } from "hooks/getHook";
import React, { memo } from "react";
import { useQuery } from "react-query";
import File from "./File";

const SharedFiles = memo(({ files, sharedFiles }) => {
  const [imageUrl, setImageUrl] = React.useState(null);
  const [fileName, setFileName] = React.useState(null);
  const [params, setParams] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const downloadFile = useQuery(
    [
      "get-files",
      {
        route: `/chat_uploads/`,
        params: params,
      },
    ],
    getMethod,
    {
      enabled: Boolean(params),
      onSuccess: (blob) => {
        console.log(blob, "blob");

        setImageUrl(blob);
      },
    }
  );
  function getFileExtension(filename) {
    // Find the last occurrence of a dot in the filename
    const lastDotIndex = filename.lastIndexOf(".");

    // Check if there is a dot and it's not the first character
    if (lastDotIndex > 0 && lastDotIndex < filename.length - 1) {
      return filename.substring(lastDotIndex + 1).toLowerCase(); // Return the extension in lowercase
    }

    // Return null if there's no valid extension
    return null;
  }
  const handleDownload = async ({ fileUrl, filename }) => {
    // The S3 file URL
    // Fetch the file as a blob
    const response = await fetch(fileUrl);
    const blob = await response.blob();

    // Create a temporary URL for the file
    const fileDownloadUrl = window.URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement("a");
    link.href = fileDownloadUrl;

    // Set the filename entered by the user, or use a default name
    link.download = `${filename}`;

    // Trigger the download
    document.body.appendChild(link);
    link.click();

    // Cleanup: remove the link after download
    document.body.removeChild(link);
    window.URL.revokeObjectURL(fileDownloadUrl);
  };

  if (sharedFiles?.isLoading) {
    return (
      <Box pt={"24px"}>
        {" "}
        <CircularProgress />
      </Box>
    );
  }
  return (
    <Box>
      <div>hel</div>
      {files.map((file, i) => (
        <File
          key={file.file}
          {...{ file }}
          onClick={() => {
            setParams({ key: file.file });
            setFileName(file.message);
            setOpen(true);
          }}
        />
      ))}

      {open && (
        <Modal
          onClick={() => {
            setOpen(false);
          }}
        >
          <Box
            onClick={(e) => {
              e.stopPropagation();
            }}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "800px",
              height: "95vh",
              bgcolor: "#fff",
              borderRadius: "10px",
              padding: "1rem",
            }}
          >
            {downloadFile.isFetching ? (
              <CircularProgress
                sx={{
                  color: "#2898A4",
                }}
              />
            ) : (
              // <FilePreview
              //   filePath={imageUrl}
              //   fileType={getFileExtension(params.key)}
              //   imageUrl={imageUrl}
              // />
              <CustomFileViewer
                fileUrl={imageUrl}
                fileType={getFileExtension(params.key)}
              />
            )}
            {/* 
              <a
                href={imageUrl}
                target="_blank"
                rel="noreferrer"
                download={params.key}
              > */}
            <Button
              onClick={() =>
                handleDownload({ fileUrl: imageUrl, filename: fileName })
              }
              variant="outlined"
              style={{
                width: "105px",
                height: "45px",
                borderRadius: "10px",
                backgroundColor: "#4069D0",
                fontFamily: "Black Sans",
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "normal",
                textTransform: "capitalize",
                marginTop: "20px",
                color: "#fff",
              }}
            >
              Download
            </Button>
            {/* </a> */}
          </Box>
        </Modal>
      )}
    </Box>
  );
});

export default SharedFiles;
